import Button from "@components/Button/Button";
import { KeywordsButtonDefaultProps } from "@components/Button/utils/types";
import { faCheck, faPlus, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cn } from "@util/helpers";

export default function KeywordButtonDefault({
  handleClick,
  isTagFollowed,
  isLoading,
  className,
}: KeywordsButtonDefaultProps): React.ReactElement {
  return (
    <Button
      onClick={handleClick}
      className={cn("ml-auto aspect-square w-full max-w-8", className)}
      aria-label={"Follow tag"}
    >
      <FontAwesomeIcon
        icon={isLoading ? faSpinner : isTagFollowed ? faCheck : faPlus}
        spin={isLoading}
        size="sm"
        color="text-gray-850"
      />
    </Button>
  );
}
